var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-4 lbv-notes" },
      [
        _c("b-card", { attrs: { header: "New note" } }, [
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c("b-form-textarea", {
                attrs: { id: "newMesage", rows: 6, "max-rows": 10 },
                model: {
                  value: _vm.message,
                  callback: function ($$v) {
                    _vm.message = $$v
                  },
                  expression: "message",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-row action" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.addNote.apply(null, arguments)
                  },
                },
              },
              [_vm._v("\n          Create Note\n        ")]
            ),
          ]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-lg-8 lbv-notes" },
      [
        _c(
          "b-card",
          { attrs: { header: "Notes" } },
          [
            _c(
              "b-list-group",
              { staticClass: "scrollable", attrs: { flush: "" } },
              _vm._l(_vm.notes, function (note, index) {
                return _c("b-list-group-item", { key: index }, [
                  _c("small", { staticClass: "note-meta" }, [
                    _c("span", { staticClass: "note-date-time" }, [
                      _vm._v(_vm._s(note.updated)),
                    ]),
                    _vm._v(" - "),
                    _c("span", { staticClass: "note-authour" }, [
                      _vm._v(_vm._s(note.username)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "note-body" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("decodeFromBase64")(note.notes)) +
                        "\n          "
                    ),
                  ]),
                ])
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }